import {getApiMetadata} from '../../helpers/api-metadata'
import {ContentType} from '../../platform/content-type'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {EditCommentRequest, IssueComment} from './contracts'

export async function apiSidePanelEditComment(body: EditCommentRequest): Promise<IssueComment> {
  const apiData = getApiMetadata('memex-edit-sidepanel-comment-api-data')

  const {data} = await fetchJSON<EditCommentRequest, IssueComment>(apiData.url, {
    method: 'PUT',
    body,
    token: apiData.token,
    contentType: ContentType.FormData,
  })

  return data
}
